type ThingWithMaybeIdAndMaybeTemporaryId = {
    id?: number;
    temporaryId?: string;
};

function indexListByTemporaryId<T extends ThingWithMaybeIdAndMaybeTemporaryId>(
    list: T[]
): Record<string, T & { temporaryId: string }> {
    return Object.fromEntries(
        list.filter((item) => item.temporaryId).map((item) => [item.temporaryId, item])
    );
}

export function assignIdsByTemporaryId(
    savedItems: ThingWithMaybeIdAndMaybeTemporaryId[],
    localItems: ThingWithMaybeIdAndMaybeTemporaryId[]
): void {
    const localItemsWithoutIds = localItems.filter((item) => !item.id);
    if (localItemsWithoutIds.length > 0) {
        const savedItemsByTemporaryId = indexListByTemporaryId(savedItems);
        for (const itemWithoutId of localItemsWithoutIds) {
            const matchedSavedItem = savedItemsByTemporaryId[itemWithoutId.temporaryId!];
            // "Transient" panels (those which are not persisted as part of a workspace) wont necessarily have
            // a matching saved item, so we check for the existence of said item before proceeding.
            if (matchedSavedItem) {
                itemWithoutId.id = matchedSavedItem.id;
                itemWithoutId.temporaryId = undefined;
            }
        }
    }
}
